// extracted by mini-css-extract-plugin
export default {"ConnectModal":"ConnectModal_DPlnD","cardsBlock":"cardsBlock_CTMFC","modalBtn":"modalBtn_gl7oY","link":"link_FcJqB"};